import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { CheckboxFieldComponent } from './components/checkbox-field/checkbox-field.component';
import { CurrencyFieldComponent } from './components/currency-field/currency-field.component';
import { DatePickerFieldComponent } from './components/date-picker-field/date-picker-field.component';
import { DurationPickerFieldComponent } from './components/duration-picker-field/duration-picker-field.component';
import { EmailTagFieldComponent } from './components/email-tag-field/email-tag-field.component';
import { ErrorMessageComponent } from './components/error-message/error-message.component';
import { InputFieldComponent } from './components/input-field/input-field.component';
import { MultiSelectFieldComponent } from './components/multi-select-field/multi-select-field.component';
import { NumberFieldComponent } from './components/number-field/number-field.component';
import { PercentageFieldComponent } from './components/percentage-field/percentage-field.component';
import { RadioFieldComponent } from './components/radio-field/radio-field.component';
import { SelectFieldComponent } from './components/select-field/select-field.component';
import { TextareaFieldComponent } from './components/textarea-field/textarea-field.component';
import { TimePickerFieldComponent } from './components/time-picker-field/time-picker-field.component';
import { ToggleFieldComponent } from './components/toggle-field/toggle-field.component';
import { ValueSwitchFieldComponent } from './components/value-switch-field/value-switch-field.component';
import { FormMasterComponent } from './form-master.component';
import { ToggleComponent } from './components/toggle/toggle.component';
import { I2gNgUiModule } from 'i2g-ng-ui';

const components = [
  FormMasterComponent,
  InputFieldComponent,
  CheckboxFieldComponent,
  RadioFieldComponent,
  SelectFieldComponent,
  TextareaFieldComponent,
  ToggleFieldComponent,
  CurrencyFieldComponent,
  DatePickerFieldComponent,
  PercentageFieldComponent,
  ValueSwitchFieldComponent,
  NumberFieldComponent,
  EmailTagFieldComponent,
  ErrorMessageComponent,
  MultiSelectFieldComponent,
  TimePickerFieldComponent,
  DurationPickerFieldComponent,
  ToggleComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    I2gNgUiModule,
  ],
  declarations: [...components],
  exports: [...components, ReactiveFormsModule],
})
export class FormMasterModule {}
